export const ApplicationConstant = {
    ApplicationID : 18,
    clientId : 11,
    organizationId: 76,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD',
    KWAppID: 17
}